import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const SchoolFeesContext = createContext();

// Custom hook to use the context
export const useSchoolFeesMode = () => {
  const context = useContext(SchoolFeesContext);
  if (!context) {
    throw new Error('useSchoolFeesMode must be used within SchoolFeesProvider');
  }
  return context;
};

// Provider component
export const SchoolFeesProvider = ({ children }) => {
  const [schoolFeesMode, setSchoolFeesMode] = useState(() => {
    // Try to get from localStorage on init
    const stored = localStorage.getItem('schoolFeesMode');
    return stored ? JSON.parse(stored) : {};
  });

  // Save to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('schoolFeesMode', JSON.stringify(schoolFeesMode));
  }, [schoolFeesMode]);

  // Set mode for a specific group
  const setModeForGroup = (groupId, isSchoolFees) => {
    console.log('🎯 Setting school fees mode for group', groupId, ':', isSchoolFees);
    setSchoolFeesMode(prev => ({
      ...prev,
      [groupId]: isSchoolFees
    }));
  };

  // Get mode for a specific group
  const getModeForGroup = (groupId) => {
    return schoolFeesMode[groupId] || false;
  };

  // Clear mode for a specific group
  const clearModeForGroup = (groupId) => {
    setSchoolFeesMode(prev => {
      const newMode = { ...prev };
      delete newMode[groupId];
      return newMode;
    });
  };

  // Clear all modes
  const clearAllModes = () => {
    setSchoolFeesMode({});
  };

  const value = {
    schoolFeesMode,
    setModeForGroup,
    getModeForGroup,
    clearModeForGroup,
    clearAllModes
  };

  return (
    <SchoolFeesContext.Provider value={value}>
      {children}
    </SchoolFeesContext.Provider>
  );
};

export default SchoolFeesContext;